import React, {useEffect, useState} from "react";
import {Typography, Modal } from '@mui/material';
import SimpleBar from 'simplebar-react';

import ButtonMain from "../button/Button_main";
import './Modal_style.scss'

import Mark from '../../assets/magicpen.svg'
import weightIcon from '../../assets/Weight-Linear.svg'


const ModalJobView = (props) => {

    const [jobReq, setJobReq] = useState({})

    //set job requirements

    useEffect(()=>{
        if(props.openJobView){
            setJobReq(props.previewPopupData)
        }
    },[props.previewPopupData])

    useEffect(()=>{console.log('jobReq', jobReq)},[jobReq])

    return(
            <Modal
                open={props.openJobView}
               // onClose={()=>props.setOpenJobView(false)}
                aria-labelledby="modal-modal-title"
            >   
                <div className="modal-container modal-view">
                {Object.keys(jobReq).length > 0 ? (
                    <>  
                        <Typography id="modal-modal-title" variant="text20" className="mb-1-modal" component="div">
                            {jobReq.title}
                        </Typography>
                        <Typography component={'div'} variant="textBaseLight" className="mb-5-modal border-bottom-modal">{jobReq.ref} | {jobReq.department}</Typography>
                        <SimpleBar className="modal-max-h-60vh-auto modal-p-0 modal-m-0">
                        {jobReq.jdDescription && jobReq.jdDescription.length > 0 && jobReq.jdDescription.map((item, index)=>(
                            <div key={index} className="jd-point">
                                <img src={Mark} alt="Mark" className="point-icon"/>
                                <div className="job-view-text-container">
                                    <Typography component={'div'} variant="textBase"className="job-view-text" >
                                        {item.requirement}
                                    </Typography>
                                    <div className="job-view-weight-wrapper">
                                        <img src={weightIcon} alt="Mark" className="point-icon"/>
                                        <Typography component={'div'} variant="textBase" className="job-view-weight">
                                            {item.weight} 
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                        ))}
                        </SimpleBar>
                        <div className="modal-footer-right mt-5-modal pt-5-modal border-top-modal">
                            <ButtonMain 
                                variant='primaryOutline' 
                                type='button' 
                                disabled={false} 
                                name='Cancel'
                                class='modal-capitalize'
                                onClick={()=>{props.setOpenJobView(false); props.setPreviewPopupData({}); setJobReq({})}}
                            />
                        </div>
                    </>
                    ):''}
                </div>
                
            </Modal>
    )
}

export default ModalJobView;